import { h, FunctionComponent } from "preact";
import { Page } from "../layout/page";
import { Gallery } from "../gallery/gallery";
import { GalleryController } from "../gallery/gallery_controller";

interface Props {
  selectedImageId?: string;
}

export const HomePage: FunctionComponent<Props> = (props) => {
  return (
    <Page fixedHeader={true}>
      <GalleryController
        galleryId="featured"
        selectedImageId={props.selectedImageId}
        showTitle={false}
      />
    </Page>
  );
};
